/* eslint-disable react/no-deprecated */
import Dialog from 'rc-dialog';
import 'rc-dialog/assets/index.css';
import React, { CSSProperties, FC, ReactElement } from 'react';
import Image from 'next/image';
import ReturnImg from '@public/images/common/return.svg';
import ReactDOM from 'react-dom';
import styles from './style.module.scss';

interface Props {
  visible: boolean;
  handleClose?: () => void;
  handleReturn?: () => void;
  width?: number | string;
  contentStyle?: CSSProperties;
  children: React.ReactNode;
}

interface ConfirmProps {
  content: string | ReactElement;
  okText?: string;
  cancelText?: string;
  onConfirm?: () => void;
}

const Modal: FC<Props> = ({ visible, handleClose, handleReturn, children, width, contentStyle }) => {
  return (
    <Dialog
      className={styles.modal}
      visible={visible}
      animation="zoom"
      maskAnimation="fade"
      width={width || 420}
      onClose={handleClose}
      // destroyOnClose
    >
      {!!handleReturn && (
        <div className={styles.returnImg} onClick={handleReturn}>
          <Image src={ReturnImg} alt="返回" />
        </div>
      )}
      <div className={styles.content} style={contentStyle}>
        {children}
      </div>
    </Dialog>
  );
};

export const showConfirmModal = ({ content, okText = '确定', cancelText = '取消', onConfirm }: ConfirmProps) => {
  const root = document.createElement('div');

  const coseModal = (
    <Modal visible={false} width={340} contentStyle={{ padding: '8px 4px 4px 4px' }}>
      {content}
      <footer className={styles.confirmFooter}>
        <div className={styles.confirmBtn} style={{ backgroundColor: '#EEE' }}>
          {cancelText}
        </div>
        <div
          className={styles.confirmBtn}
          style={{ color: '#fff', background: 'linear-gradient(90deg, #FF5353 8.55%, #6D38FB 61.14%, #009DFF 100%)' }}
        >
          {okText}
        </div>
      </footer>
    </Modal>
  );

  const handleCancel = () => {
    ReactDOM.render(coseModal, root);
    document.body.append(root);
    setTimeout(() => {
      ReactDOM.unmountComponentAtNode(root);
      document.body.removeChild(root);
    }, 300);
  };

  const handleConfirm = () => {
    onConfirm?.();
    handleCancel();
  };

  const modal = (
    <Modal visible width={340} contentStyle={{ padding: '8px 4px 4px 4px' }}>
      {content}
      <footer className={styles.confirmFooter}>
        <div onClick={handleCancel} className={styles.confirmBtn} style={{ backgroundColor: '#EEE' }}>
          {cancelText}
        </div>
        <div
          onClick={handleConfirm}
          className={styles.confirmBtn}
          style={{ color: '#fff', background: 'linear-gradient(90deg, #FF5353 8.55%, #6D38FB 61.14%, #009DFF 100%)' }}
        >
          {okText}
        </div>
      </footer>
    </Modal>
  );

  ReactDOM.render(modal, root);
  document.body.append(root);
};

export default Modal;
